import styled from 'styled-components';
import {commonPalette} from 'styles/palette';

export const SignaturePadWrapper = styled.div.attrs({
  className: 'swiper-no-swiping'
})``;

const dottedBorder = (width, height, color, offset) => {
  const OPEN_BRACKET = '%3c';
  const CLOSE_BRACKET = '%3e';

  const svg = `
    <svg width='${width}px' height='${height}px' xmlns='http://www.w3.org/2000/svg'>
      <rect
        width='${width - 10}px'
        height='${height - 10}px'
        x='5px'
        y='5px'
        fill='none'
        rx='6'
        ry='6'
        stroke='${color}'
        stroke-width='2'
        stroke-dasharray='15'
        stroke-dashoffset='${offset}'
        stroke-linecap='square'/>
    </svg>
`;

  return `url("data:image/svg+xml,${svg.replace(/</g, OPEN_BRACKET).replace(/>/g, CLOSE_BRACKET)}")`;
};

export const PreviewButton = styled.button`
  min-height: 60px;
  display: flex;
  flex: 1;
  background-color: ${commonPalette.darkerGray};
  border: none;
  background-image: ${p => dottedBorder(p.maxWidth, p.maxHeight, 'lightgray', 10)};
  border-radius: 6px;
  max-height: ${p => p.maxHeight}px;
  max-width: ${p => p.maxWidth}px;
  transition: all 0.3s ease-in-out;
  cursor: pointer;

  &:hover {
    background-image: ${p => dottedBorder(p.maxWidth, p.maxHeight, 'gray', 15)};
  }
`;

export const Placeholder = styled.div`
  margin: auto;
  color: lightgray;
  font-style: italic;

  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease-in-out;
  &:hover {
    color: gray;
    transform: scale(1.05);
  }
`;

export const Dialog = styled.dialog`
  padding: 16px;
  border: 0;
  z-index: 10;
  position: fixed;
  border-radius: 8px;
  overflow: hidden;

  &::backdrop {
    position: fixed;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    background: rgba(0, 0, 0, 0.5);
  }
`;

export const DialogContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1px;
  padding-top: 16px;
  justify-content: space-between;
`;

export const Button = styled.button`
  padding: 4px 12px;
  border: none;
  background-color: ${commonPalette.sgGreen};
  color: white;
  text-transform: uppercase;
  border-radius: 3px;
  outline: none;
  ${p => {
    if (p.secondary) {
      return `
            color: ${commonPalette.txLightGrey};
            background-color: ${commonPalette.disabledText};
        `;
    }
  }}
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 16px;
`;

export const Title = styled.h2`
  font-size: 18px;
  font-weight: 500;
  margin: 0;
`;

export const CloseButton = styled.button`
  outline: none;
  position: relative;
  width: 24px;
  height: 24px;
  border: none;
  background: none;
  cursor: pointer;
  transition: opacity 0.3s ease-in-out;
  opacity: 1;
  &:hover {
    opacity: 0.5;
  }
  &:active {
    opacity: 0.8;
  }
  &:after,
  &:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 24px;
    height: 2px;
    background-color: #000;
    transform: translate(-50%, -50%) rotate(45deg);
  }
  &:before {
    transform: translate(-50%, -50%) rotate(-45deg);
  }
`;

export const CanvasContainer = styled.div`
  display: flex;
  justify-content: center;

  position: relative;
`;

export const Pad = styled.canvas`
  background-color: #f5f5f5;
  width: ${p => p.width}px;
  height: ${p => p.height}px;
  cursor: crosshair;
`;

export const ClearButton = styled.button`
  padding: 4px 12px;
  border: none;
  outline: none;
  color: ${commonPalette.txLightGrey};
  background-color: ${commonPalette.disabledText};
  text-transform: uppercase;
  border-radius: 3px;
  font-size: 14px;
  cursor: pointer;
  position: absolute;
  top: 12px;
  left: 12px;
`;

export const ColorsContainer = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  display: flex;
  justify-content: center;
  gap: 8px;
`;

// Add check if selected
export const ColorButton = styled.button`
  width: 12px;
  height: 12px;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  background-color: ${p => p.color};
  outline: none;
  transition: all 0.3s ease-in-out;

  &:hover {
    transform: scale(1.12);
  }
  ${p =>
    p.selected &&
    `
    transform: scale(1.12);
    &:after {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        color:white;
        content: '✓';
        font-size: 8px;
    }
  `}
`;

export const COLORS = {
  blue: commonPalette.blue,
  black: commonPalette.txBlack,
  red: commonPalette.red
};
